
import { Vue } from "vue-class-component";

export default class Reload extends Vue {}
